import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Security } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import { Slide, ToastContainer } from 'react-toastify';
import PaperHeader from './Header';
import { oktaConfig } from './auth/AuthConfig';
import { AuthProvider } from './auth/AuthContext';
import { AppRoutes } from './AppRoutes';
import { loadSavedFilters, saveFiltersToStorage } from './utils/helper';

import 'react-toastify/dist/ReactToastify.css';
import './App.css';

const queryClient = new QueryClient();
export const oktaAuth = new OktaAuth(oktaConfig);

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleBeforeUnload = () => {
      saveFiltersToStorage(loadSavedFilters().map((f) => ({ ...f, isActive: false })));
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const restoreOriginalUri = (_oktaAuth: any, originalUri: string) => {
    navigate(toRelativeUrl(originalUri || '/', window.location.origin), { replace: true });
  };

  return (
    <QueryClientProvider client={queryClient}>
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <AuthProvider>
          <PaperHeader />
          <AppRoutes />
          <ToastContainer
            position="top-center"
            hideProgressBar
            newestOnTop={false}
            closeOnClick
            pauseOnFocusLoss
            draggable
            pauseOnHover
            transition={Slide}
          />
        </AuthProvider>
      </Security>
    </QueryClientProvider>
  );
}

export default App;
